import Modals from './modals'
export default Modals
